import { render, staticRenderFns } from "./Index02.vue?vue&type=template&id=fbc4c2b8&scoped=true"
import script from "./Index02.vue?vue&type=script&lang=js"
export * from "./Index02.vue?vue&type=script&lang=js"
import style0 from "./Index02.vue?vue&type=style&index=0&id=fbc4c2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc4c2b8",
  null
  
)

export default component.exports